export default class YoutubeVideo {
  constructor() {
    this.url = ""
  }
}
